import { withControlledFormComponentValue } from '../../with-controlled-form-component-value';
import DateTimePicker from './date-time-picker';
export { default as DateTimePicker } from './date-time-picker';

// make it default export with 'ditto_uim_jsm_datetime_field_support' cleanup
export const ControlledDateTimePicker = withControlledFormComponentValue(
	(_field: string, value: string) => value,
)(DateTimePicker);
